// extracted by mini-css-extract-plugin
export default {"sort":"SW-z","sortSelect":"TW-z","disabled":"UW-z"};